export function injectScript(id, scriptString) {
  try {
    if (document.getElementById(id)) {
      console.log(`Script with id ${id} already exists`);
      return;
    }
    const scriptElement = document
      .createRange()
      .createContextualFragment(scriptString);

    const scriptContainer = document.createElement('div');
    scriptContainer.setAttribute('id', id);
    scriptContainer.appendChild(scriptElement);

    document.body.appendChild(scriptContainer);
  } catch (e) {
    console.error('Failed to insert script ', scriptString);
    console.error('Error: ', e);
  }
}
